import { Employee as EmployeeNode } from "@acto/gql/graphql";

export default class Employee {
  constructor(
    public readonly id: string,
    public readonly name: string,
  ) {}

  static fromGraphql(data: EmployeeNode): Employee {
    return new Employee(data.id, data.name);
  }
}
